/********** YOSHIKI GOODS **********/
    /* addclass */
      $(document).ready(function(){
        $('body').addClass('yoshiki');
      });
    /* /addclass */

    /* accordion */
    $(function() {
      $('div.homepage-featured-rich-text').on('click', function() {
        $(this).toggleClass('fold');
        // $(this).next().children('p').slideToggle(500);
        $(this).next('div').slideToggle(500);
      });
    });
  /* /accordion */
/********** /YOSHIKI GOODS **********/